module.exports = __webpack_public_path__ + "static/img/aqzs03.047aa762.jpg";